import { getDevAccessHeaders } from '@educator/lib/utils/devStagingAccessHeaders'
import { OpenAPI as EducatorOpenAPI } from '@mc/educator-api'

export const tryCatch = async <T>(
  f: () => Promise<T>,
): Promise<{ data: T } | { error: unknown }> => {
  try {
    return { data: await f() }
  } catch (error) {
    return Promise.resolve({ error })
  }
}

// For server-side requests (SSR), point EducatorOpenAPI at the educator BFF
// directly. Client-side BASE is set in _app.page.tsx and routes through the
// Next.js proxy (which handles auth and forwards to EDUCATOR_API_URL).
//
// Call this from every getServerSideProps that hits the educator API, before
// invoking any LearningService method. We do this as an explicit function call
// rather than a module-level side effect because the app declares
// `sideEffects: false` in package.json, which causes webpack to tree-shake
// top-level statements out of production builds.
export const setEducatorApiBaseForSSR = (): void => {
  const base = process.env.EDUCATOR_API_URL
  if (!base) {
    throw new Error(
      'EDUCATOR_API_URL is required for server-side educator API calls',
    )
  }
  EducatorOpenAPI.BASE = base
  EducatorOpenAPI.HEADERS = {
    ...EducatorOpenAPI.HEADERS,
    ...getDevAccessHeaders(),
  }
}

export * from '@mc/educator-api'
export { EducatorOpenAPI }
